import { ContextBuilder } from 'context/nutriscoreLabelContext';

import BaseIngredientSearchComponent from 'components/desktop/BaseIngredient/Search/BaseIngredientSearchComponent';

interface IProps {
	archive: boolean;
}

const BaseIngredientSearchContainer = ({ archive }: IProps) => {
	return (
		<main className="container">
			<BaseIngredientSearchComponent archive={archive} />
		</main>
	);
};

export default ContextBuilder.From(BaseIngredientSearchContainer)
	.wrapWithNutriscoreContext()
	.build();
